import httpService from 'services/http/http.service';
import ApiUrl from 'enum/api-url.enum';

function getWelcomeNote() {
  return httpService.get(ApiUrl.WELCOMENOTE);
}

const obj = { getWelcomeNote };

export default obj;
